export const getSanitizeSlug = (slug?: string) => {
    const isTypeOfString = typeof slug === 'string';
    const sanitizeSlug = isTypeOfString ? slug?.split(/(\?|&)/, 1)[0] : slug;

    return sanitizeSlug || '';
};
